import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VagaDetalhesComponent } from './fisico/paginas/vaga-detalhes/vaga-detalhes.component';
import { NaoEncontradaComponent } from './juridico/paginas/nao-encontrada/nao-encontrada.component';
import { environment } from 'src/environments/environment';
import { dataSeo } from './app.data.seo';


const routes: Routes = [
  { path: 'vaga-nao-encontrada', component: NaoEncontradaComponent, data: dataSeo.vagaNaoEncontrada },
  { path: '', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: ':idVaga', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: ':empresa/:idVaga', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: ':empresa/:titulo/:codigo/:cidade/:estado', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: ':empresa/:titulo/:codigo/:cidade/:estado/:modalidade', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: 'chance/:idVaga', component: VagaDetalhesComponent, data: dataSeo.vagaDetalhes },
  { path: '**', component: NaoEncontradaComponent, data: dataSeo.paginaNaoEncontrada },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
